export default __webpack_public_path__ + "static/media/Andhra_Hover.ce0b6007.svg";